// extracted by mini-css-extract-plugin
module.exports = {"content":"Setting_content__1cHT2","hideScrollableTable":"Setting_hideScrollableTable__3gjPP","container":"Setting_container__256to","header":"Setting_header__1FUpx"};